<template>
  <span class="align-container">
    <span class="align-left" v-if="inspectStatus">
      <el-button
          size="mini"
          v-for="(btn,index) in buttons"
          :key="index"
          :type="btn.type"
          @click="btn.onClick">{{ btn.text }}
      </el-button>
      <el-dropdown v-if="toolbarSelects&&toolbarSelects.length>0" style="margin-left: 10px;"
                   @command="handleSelectOpt">
        <el-button type="warning" size="mini">
          {{ currentOpt || '请选择快捷操作' }}<i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu v-slot="dropdown">
          <el-dropdown-item v-for="(select,index) in toolbarSelects"
                            :key="index"
                            :command="select.value">
            {{ select.label }}
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-pagination
          v-if="showPagination"
          small
          style="margin-left: 10px;"
          @current-change="handleCurrentChange"
          :page-size="pageSize"
          :current-page="currentPage"
          layout="prev, pager, next"
          :total="totalItems"></el-pagination>
    </span>
    <span class="align-left" v-else></span>
    <span class="align-center">当前项目ID：{{ projectId }},场所ID：{{ siteId }}</span>
    <span class="align-right">
      <RouteSelector :project-id="projectId" :site-id="siteId" :currentRoute="currentRoute"
                     :siteType="siteType"></RouteSelector>
    </span>
  </span>
</template>
<script>
import RouteSelector from "@/components/RouteSelector.vue";

export default {
  components: {RouteSelector},
  props: {
    inspectStatus: {
      type: Boolean,
      required: true
    },
    buttons: {
      type: Array,
      required: true
    },
    projectId: {
      type: String,
      required: true
    },
    siteId: {
      type: String,
      required: true
    },
    siteType: {
      type: String,
      required: true
    },
    currentRoute: {
      type: String,
      required: true
    },
    currentOpt: {
      type: String,
      default: ''
    },
    toolbarSelects: Array,
    showPagination: {
      type: Boolean,
      default: false
    },
    totalItems: {
      type: Number,
      default: 0
    },
    pageSize: {
      type: Number,
      default: 1
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  methods: {
    handleSelectOpt(command) {
      this.$emit('selectCommand', command)
    },
    handleCurrentChange(page) {
      this.$emit('currentChange', page)
    }
  }
}
</script>

<style scoped>
.align-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.align-left {
  flex: 1;
  display: flex;
  justify-content: flex-start;
}

.align-center {
  flex: 1;
  display: flex;
  justify-content: center;
}

.align-right {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
</style>